/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "common/v3/generic/asset.proto" (package "fubo.tv.proto.common.v3.generic", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message fubo.tv.proto.common.v3.generic.Asset
 */
export interface Asset {
    /**
     * @generated from protobuf field: optional string asset_id = 1;
     */
    asset_id?: string;
    /**
     * @generated from protobuf field: optional bool broadcasting_now = 2;
     */
    broadcasting_now?: boolean;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Asset.AssetType asset_type = 3;
     */
    asset_type?: Asset_AssetType;
}
/**
 * @generated from protobuf enum fubo.tv.proto.common.v3.generic.Asset.AssetType
 */
export enum Asset_AssetType {
    /**
     * @generated from protobuf enum value: unknown_asset_type = 0;
     */
    unknown_asset_type = 0,
    /**
     * @generated from protobuf enum value: vidai_playlist = 1;
     */
    vidai_playlist = 1,
    /**
     * @generated from protobuf enum value: vidai_team_channels = 2;
     */
    vidai_team_channels = 2,
    /**
     * @generated from protobuf enum value: vidai_timeline_markers = 3;
     */
    vidai_timeline_markers = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class Asset$Type extends MessageType<Asset> {
    constructor() {
        super("fubo.tv.proto.common.v3.generic.Asset", [
            { no: 1, name: "asset_id", kind: "scalar", localName: "asset_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Asset ID." } },
            { no: 2, name: "broadcasting_now", kind: "scalar", localName: "broadcasting_now", opt: true, T: 8 /*ScalarType.BOOL*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "true", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Is the content now broadcasting ?" } },
            { no: 3, name: "asset_type", kind: "enum", localName: "asset_type", opt: true, T: () => ["fubo.tv.proto.common.v3.generic.Asset.AssetType", Asset_AssetType], options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "vidai_playlist", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Asset type." } }
        ]);
    }
    create(value?: PartialMessage<Asset>): Asset {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Asset>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Asset): Asset {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string asset_id */ 1:
                    message.asset_id = reader.string();
                    break;
                case /* optional bool broadcasting_now */ 2:
                    message.broadcasting_now = reader.bool();
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Asset.AssetType asset_type */ 3:
                    message.asset_type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Asset, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string asset_id = 1; */
        if (message.asset_id !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.asset_id);
        /* optional bool broadcasting_now = 2; */
        if (message.broadcasting_now !== undefined)
            writer.tag(2, WireType.Varint).bool(message.broadcasting_now);
        /* optional fubo.tv.proto.common.v3.generic.Asset.AssetType asset_type = 3; */
        if (message.asset_type !== undefined)
            writer.tag(3, WireType.Varint).int32(message.asset_type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.common.v3.generic.Asset
 */
export const Asset = new Asset$Type();
